/* ==========================================================================
   MENSTRUAL KAP KULLANIMI — Cinematic Animation Engine
   ========================================================================== */
(function () {
  if (window.__mkkAnimInit) return;
  window.__mkkAnimInit = true;

  /* ---- Particle field (disabled) ---- */
  function initParticles() {
    return;
  }

  /* ---- Scroll reveal for [data-mkk-anim] ---- */
  function initReveals() {
    var els = document.querySelectorAll('[data-mkk-anim]:not(.mkk-vis)');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var delay = parseInt(e.target.getAttribute('data-mkk-delay') || '0', 10) * 120;
          setTimeout(function () { e.target.classList.add('mkk-vis'); }, delay);
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -50px 0px', threshold: 0.1 });
    els.forEach(function (el) { obs.observe(el); });

    /* Fallback if observer never fires (e.g. fast scroll, layout shift) */
    setTimeout(function () {
      els.forEach(function (el) {
        if (!el.classList.contains('mkk-vis')) el.classList.add('mkk-vis');
      });
    }, 2000);
  }

  /* ---- Tips checklist activation ---- */
  function initTips() {
    var containers = document.querySelectorAll('[data-mkk-tips]');
    if (!containers.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var tips = e.target.querySelectorAll('.mkk-tip');
        tips.forEach(function (tip, idx) {
          setTimeout(function () { tip.classList.add('is-active'); }, 200 + idx * 350);
        });
        obs.unobserve(e.target);
      });
    }, { threshold: 0.15 });
    containers.forEach(function (c) { obs.observe(c); });
  }

  /* ---- Master init ---- */
  function initAll() {
    initReveals();
    initTips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();
